export const locationKeys = {
  all: ['locations'] as const,
  detail: (id: string): readonly unknown[] => [...locationKeys.all, 'detail', id] as const,
  search: (params?: Record<string, unknown>): readonly unknown[] => [...locationKeys.all, 'search', params] as const,
};
